import type { PropsWithChildren } from 'react';

import { FileViewerControlsSectionStyled } from './styles/FileViewerControlsSectionStyled'
import { Card } from '@ui/elements/Card'

export interface IFileViewerControlsSectionProps {}

export const FileViewerControlsSection = ({
  children,
}: PropsWithChildren<IFileViewerControlsSectionProps>) => {
  return (
    <FileViewerControlsSectionStyled>
      <Card>
        <Card.Content p={1}>{children}</Card.Content>
      </Card>
    </FileViewerControlsSectionStyled>
  )
}
